<elio-lazy-loaded-chunk-loader></elio-lazy-loaded-chunk-loader>
<elio-toast></elio-toast>
<router-outlet name="popup"></router-outlet>
<router-outlet></router-outlet>
<elio-cookie-consent *ngIf="displayCookieConsent$ | async" />
